<template>
  <div class="record">
    <div class="record__btns">
      <template v-for="(btn, i) in btns">
        <div
          class="record__btn"
          :key="i"
          @click="
            onClickBtn(btn);
            report(btn);
          "
        >
          <!-- <span style="font-size: 250%; line-height: 1;">+</span> -->
          <!-- <span>{{btn.name}}</span> -->
          <i :class="[`icon-${btn.icon}`]"></i>
        </div>
        <div
          class="common-vip-tip"
          v-if="btn.type == 'generate'"
          v-show="showVipTip"
        ></div>
      </template>
    </div>
    <div class="record__info">
      <template v-for="btn in btns">
        <div :key="btn.type" class="record__info-item">
          <div>{{ btn.name }}</div>
          <div>{{ btn.info[0] }}</div>
          <div>{{ btn.info[1] }}</div>

          <div class="smart-voice-tip" v-if="btn.tip">{{ btn.tip }}</div>
        </div>
      </template>
    </div>
    <label ref="uploadTrigger" for="audio"></label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import analysis from '@/components/mixins/analysis/soundRecord';
import addSound from '@/components/rightnav/slide/addSound.js';

export default {
  mixins: [analysis, addSound],
  data () {
    return {
      btns: [
        {
          name: 'AI合成',
          badge: '',
          type: 'generate',
          info: ['输入文字', 'AI智能合成'],
          icon: 'brain',
          tip: '',
          remain: 0
        },
        {
          name: '上传',
          badge: '',
          type: 'upload',
          info: ['从本地上传已经', '准备好的声音文件'],
          icon: 'upload-up'
        },
        {
          name: '直接录音',
          badge: '',
          type: 'record',
          info: ['使用麦克风设备', '直接录制'],
          icon: 'mic'
        }
      ],
      showVipTip: false
    }
  },
  computed: {
    ...mapGetters([
      'TopNav_Size',
      'SoundRecord',
      'TOOL',
      'SelectScenes_Msg',
      'BGM',
      'UserLevel',
      'UserLevelType',
      'UserMsg',
      'StyleMsg',
      'isPersonVip'
    ]),
    isSoloUser () {
      return this.isPersonVip;
    }
  },
  created () {
    this.setBadges();

    this.$bus.on('placeSmartVoice.hide', () => {
      this.showGenerateVoice();
    });
    this.$bus.on('placeSmartVoice.goOn', () => {
      this.$store.commit('set_PreviewType', 'global');
    });
    this.$bus.on('placeSmartVoice.cancel', () => {
      this.$store.commit('set_PreviewType', 'scene');
    });

    this.getSmartVoiceInfo();
  },
  methods: {
    onClickBtn (obj) {
      let { type } = obj;
      if (type === 'generate') {
        //   if (this.UserLevelType <= 1 && this.UserLevel !== 25) {
        //     this.$bus.emit('FeaturesPop_vue', {
        //       name   : "vipEquity",
        //       msg    : '升级个人VIP，解锁30次AI配音权益。',
        //       type   : 2,
        //       btnMsg : '开通企业会员',
        //       btnMsgLink  : '/workplace/vipsolo',
        //       baiduAction : 'upgradeAidubVip',
        //     });
        //     return;
        //   }

        //   if (this.UserLevel === 25 && obj.remain === 0) {
        //     this.$bus.emit('FeaturesPop_vue', {
        //       name   : "vipEquity",
        //       msg    : '您的视频无水印次数已用完，请购买资源包叠加权益或者开通企业会员无限使用。',
        //       type   : 2,
        //       btnMsg : '开通企业会员',
        //       btnMsgLink  : '/payment?levelType=2',
        //       baiduAction : 'upgradeAidubVip',
        //     });
        //     return;
        //   }

        // this.$modal.show('placeSmartVoice');

        this.$store.commit('subtitle/setStartType', 'smart');
        this.$bus.emit('openSubtitleLayer');
      }

      if (type === 'upload') {
        // if (!this.UserMsg.uploadRecordingRemain && this.UserLevelType <= 1) {
        //   let opts = {};
        //   if (this.UserLevelType === 1) {
        //     this.setBadges();
        //     this.uploadRemain.isShow = true;
        //     opts = {
        //       msg: '上传录音次数已用完，如需继续使用，还请升级为高级会员',
        //       btnMsg: '开通企业会员',
        //       btnMsgLink : '/payment?levelType=2',
        //     }
        //   }

        //   this.$bus.emit('FeaturesPop_vue', {
        //     name : "vipEquity",
        //     msg : '上传录音为会员功能，如需使用，还请升级为会员',
        //     btnMsg : '升级会员免费用',
        //     btnMsgLink : '/payment?levelType=1',
        //     type : 2,
        //     ...opts
        //   });
        //   return;
        // }

        // this.$refs.uploadTrigger.click();

        this.openSoundtrackStore(type);
      }
      if (type === 'record') {
        // if (!window.navigator.mediaDevices) {
        //   this.$modal.show('recordErrorTip', { type: 'noFunction' });
        //   return;
        // }

        // window.navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
        //   stream.getTracks()[0].stop();
        //   this.$modal.show('selectRecord')
        //   this.$analysis({ category: 'recording_classification', action: 'click_recording_making_directly', label: '直接录音' })
        // }).catch((error) => {
        //   console.log(error.name)
        //   this.$modal.show('recordErrorTip', { type: error.name });
        // });

        this.openSoundtrackStore(type);
      }
    },
    openSoundtrackStore (type = 'upload') {
      // let sound = this.findMin(this.dubbingArr);
      // if (sound && sound.timeSlot[0] > 0.2 || !sound) {
      //   this.$store.commit('subtitle/setStartType', type);
      // }
      // if (sound && sound.timeSlot[0] <= 0.2) {
      //   this.$message({
      //     message: '当前位置已有声音，可进入“声音与字幕”调整修改。',
      //     type: "error",
      //   });
      // }

      this.$store.commit('subtitle/setStartType', type);
      this.$bus.emit('openSubtitleLayer');
    },
    showGenerateVoice () {
      this.$store.commit('save_SoundRecord', {
        isShowGenerateVoice: true,
      });
    },
    setBadges () {
      if (this.UserLevelType < 2 && !this.isPersonVip) {
        // this.btns[0].badge = 'VIP';
        this.showVipTip = true;
      } else {
        this.showVipTip = false;
      }
    },
    getSmartVoiceInfo () {
      let { kdxfRemain, kdxfTimes } = this.UserMsg;
      // let temp = kdxfTimes ? `您共有${kdxfTimes}次AI配音权益，目前还剩余${kdxfRemain}次。` : '';
      // let temp = kdxfTimes ? `目前还剩余${kdxfRemain > 999 ? '999+' : kdxfRemain}次AI配音权益。` : '';
      let temp = '';
      if (kdxfTimes > 999) {
        temp = '';
      } else if (typeof kdxfRemain === number) {
        temp = `目前还剩余${kdxfRemain}次AI配音权益。`
      }
      if (this.UserLevelType >= 2) {
        temp = '';
      }
      this.btns[0].tip = temp;
      this.btns[0].remain = kdxfRemain;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/colors';
.record {
  position: relative;
  // height: 520px;

  &__btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 50px 0;
  }
  &__btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100px;
    height: 90px;
    box-sizing: border-box;
    border: 1px $c8 solid;
    border-radius: 2px;
    cursor: pointer;

    &:hover {
      border-color: #5778fb;
    }

    > .badge {
      position: absolute;
      top: -4px;
      right: -4px;
      width: 40px;
      height: 23px;
      border-radius: 23px;
      text-align: center;
      line-height: 23px;
      color: $c0;
      background-color: $c11;
    }
  }
  &__info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px 20px;
  }
  &__info-item {
    position: relative;
    width: 100px;
    &:nth-of-type(2) {
      width: 120px;
    }
    > div {
      text-align: center;
      white-space: nowrap;
      padding-bottom: 6px;
      font-size: 12px;
      &:nth-of-type(1) {
        padding-top: 12px;
        padding-bottom: 12px;
        font-size: 14px;
        font-weight: 800;
      }
    }
  }
  &__player {
    margin-left: auto;
    margin-right: auto;
    margin-top: 12px;
  }
  &__list-wrapper {
    position: relative;
    bottom: 0;
    left: 0;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  &__list {
    width: 270px;
    margin: auto;
    padding-bottom: 20px;
  }
  &__empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 260px;
    > i {
      margin-bottom: 20px;
    }
  }
  &__remain-tip {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba($c2, 0.7);
    color: white;
    font-size: 12px;

    > span {
      width: 80%;
      padding: 0 20px;
    }
    > i {
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:before,
      &:after {
        background-color: white;
      }
    }
  }
}

.common-vip-tip {
  position: absolute;
  top: 12px;
  left: 135px;
  width: 36px;
  height: 16px;
  background-image: url(../../../../static/svg/payTypeSubscript/vip36x16.svg);
  background-size: cover;
  background-repeat: no-repeat;
}

.smart-voice-tip {
  position: absolute;
  left: 0;
  top: -112px;
  color: #5778fb;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/mySoundRecord/soundRecordLite.vue